import React from 'react'
import { Headline } from 'uiComponents/typography'
import { ContentSection } from 'uiComponents/pageElements'
import { SingleSelect } from 'uiComponents/input/singleSelect'
import { FormItem, FormItemName } from 'uiComponents/form/formElements'
import { t } from 'translations'

export type ReportFrequencyType = 'never' | 'daily' | 'weekly' | 'monthly'

export const getReportFrequencyOptions = () => [
    { name: t('settings.notifications.performanceReports.frequency.never'), value: 'never' },
    { name: t('settings.notifications.performanceReports.frequency.daily'), value: 'daily' },
    { name: t('settings.notifications.performanceReports.frequency.weekly'), value: 'weekly' },
    { name: t('settings.notifications.performanceReports.frequency.monthly'), value: 'monthly' },
]

export const getWeekdayOptions = () => [
    { name: t('settings.notifications.performanceReports.weekdays.monday'), value: '1' },
    { name: t('settings.notifications.performanceReports.weekdays.tuesday'), value: '2' },
    { name: t('settings.notifications.performanceReports.weekdays.wednesday'), value: '3' },
    { name: t('settings.notifications.performanceReports.weekdays.thursday'), value: '4' },
    { name: t('settings.notifications.performanceReports.weekdays.friday'), value: '5' },
    { name: t('settings.notifications.performanceReports.weekdays.saturday'), value: '6' },
    { name: t('settings.notifications.performanceReports.weekdays.sunday'), value: '0' },
]

interface ComponentProps {
    reportFrequency: ReportFrequencyType
    weekday: string
    setReportFrequency: (value: string) => void
    setWeekday: (value: string) => void
}

export function PerformanceReports(props: ComponentProps) {
    return (
        <ContentSection style={{ marginTop: '0.4rem' }}>
            <Headline size={4}>{t('settings.notifications.performanceReports.title')}</Headline>
            <FormItem htmlFor="report-frequency">
                <FormItemName>{t('settings.notifications.performanceReports.frequencyLabel')}</FormItemName>
                <SingleSelect
                    id="report-frequency"
                    options={getReportFrequencyOptions()}
                    selected={props.reportFrequency}
                    onSelect={props.setReportFrequency}
                />
            </FormItem>
            {props.reportFrequency === 'weekly' && (
                <FormItem htmlFor="week-start" style={{ marginTop: '1rem' }}>
                    <FormItemName>{t('settings.notifications.performanceReports.weekdayLabel')}</FormItemName>
                    <SingleSelect
                        id="week-start"
                        options={getWeekdayOptions()}
                        selected={props.weekday}
                        onSelect={props.setWeekday}
                    />
                </FormItem>
            )}
        </ContentSection>
    )
}
